module.exports = __webpack_public_path__ + "static/media/意见反馈 (2).7cfde1ea.svg";